module.exports = __webpack_public_path__ + "img/애고미_이모티콘-26.91d9c6e.png";